export default __webpack_public_path__ + "static/media/icon_ETH.ec869469.svg";